import React, {type FC, memo, useMemo} from 'react';

import {type Tag} from '../../../../util/gallery';
import {trackBreadcrumbClicked} from '../../../../util/navigation';
import * as links from '../../../../util/urls';
import Breadcrumbs, {type BreadcrumbPart} from '../../../Breadcrumbs';

export type NavBreadcrumbsFCPostProps = {
  entityName: string;
  reportID: string;
  reportName: string;
  tag?: Tag;
  isDiscussion: boolean;
};

export function useNavBreadcrumbsFCPostParts({
  entityName,
  reportID,
  reportName,
  tag,
  isDiscussion,
}: NavBreadcrumbsFCPostProps): BreadcrumbPart[] {
  const tagLinkForm = tag?.linkForm;
  const label = isDiscussion ? `Discussions` : `Posts`;

  const parts: BreadcrumbPart[] = useMemo(() => {
    if (tagLinkForm == null) {
      return [];
    }

    return [
      {label: `Fully Connected`, to: links.reportGallery()},
      {label, to: links.reportGallery({tag: tagLinkForm})},
      {
        label: reportName,
        to: `${(isDiscussion
          ? links.galleryDiscussionView
          : links.galleryPostView)({
          entityName,
          reportID,
          reportName,
        })}${window.location.search}`,
        onClick: () => trackBreadcrumbClicked('Report'),
      },
    ];
  }, [entityName, reportID, reportName, isDiscussion, tagLinkForm, label]);

  return parts;
}

const NavBreadcrumbsFCPostComp: FC<NavBreadcrumbsFCPostProps> = params => {
  const parts = useNavBreadcrumbsFCPostParts(params);
  return <Breadcrumbs parts={parts} />;
};

const NavBreadcrumbsFCPost = memo(NavBreadcrumbsFCPostComp);

export default NavBreadcrumbsFCPost;
